import { createRouter, createWebHashHistory } from 'vue-router'
import mainComponent from '../components/CorComponent.vue'
import home from '../views/home.vue'
import table from '../views/table.vue'
import estimates from '../views/estimates.vue'
import statement from '../views/statement.vue'
import library from '../views/Library.vue'
import messages from '../views/messages.vue'
import login from '../views/login.vue'
const routes = [
  {
    path:'/',
    name:'Main',
    component:mainComponent,
    children:[
      {
        path:'/',
        name:'Home',
        component:home,
        meta:{
          requireAuth:true
        }
      },
      
      {
        path:'/table',
        name:'Table',
        component:table,
        meta:{
          requireAuth:true
        }
    },
      {
        path:'/estimates',
        name:'Estimates',
        component:estimates,
        meta:{
          requireAuth:true
        }
      },
      {
        path:'/statement',
        name:'Statement',
        component:statement,
        meta:{
          requireAuth:true
        }

      },
      {
        path:'/library',
        name:'Library',
        component:library,
        meta:{
          requireAuth:true
        }

      },
      {
        path:'/messages',
        name:'Messages',
        component:messages,
        meta:{
          requireAuth:true
        }

      }
     

    ]
  },
  {
    path:'/login',
    name:'ავტორიზაცია',
    component:login

  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach((to,from,next)=>{

  if(to.matched.some(record=>record.meta.requireAuth)){
    if(localStorage.getItem('token')){

      next()
    }else{
      next('/login')
    }


  }else{
    next()
  }


})

export default router
